module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("In Which Vital History Concerning Her Majesty Is Revealed")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("When informed at the age of ten that she was likely to be queen of England, it was reported that Her Royal Highness Princess Alexandrina Victoria of Kent replied, “I will be good.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What she actually said was, “I will "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("do")]), _vm._v(" good.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sometime in 1835—it is a well-kept secret—the sixteen-year-old princess escaped her highly managed routine and spent two weeks walking incognito among commoners. The revelation of how ordinary folk lived and died made a profound impression on young “Drina.” She resolved to improve the lot of her people, especially that of women.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("During this taste of freedom, she met the dashing Lord Arthur Godalming, who was in the right place at the right time to rescue her from street ruffians. It was love at first sight for both, and when she became queen two years later, iron-willed Victoria defied custom and changed law so she could marry a peer rather than a prince.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The love match of Victoria and the Lord Consort Arthur marked the beginning of a new era of enlightenment for England.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her progressive policies, particularly the historic “Time of Women” Equal Franchise Act of 1859, which granted voting rights to women, changed the world.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The young monarch made her childhood declaration a reality.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Victoria’s empire now circles the globe, but the brass and steam progress of the Industrial Revolution disturbed dark forces. Reason and science were in vigorous conflict against fear and superstition. The empress could not ignore the fact that something was supernaturally rotten in the state of England. In 1847 she called for the creation of a new department within the Ministry of Science.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This special branch, Her Majesty’s Psychic Service, dedicated to investigating all matters supernatural, employs the psychical gifts of those who serve in it to protect and preserve the realm.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Here follows the story of one of her agents.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0